import React from "react"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "../../../../_metronic/_helpers"

export const DeleteSvgIcon = () => {
  return (
    <span className="svg-icon svg-icon-md svg-icon-primary">
      <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Delete.svg")} />
    </span>
  )
}
